/** Normalize seat_structure fields from Directus (JSON strings or objects). */
export function parseJsonField(val, fallback) {
  if (val == null) return fallback;
  if (Array.isArray(val)) return val;
  if (typeof val === "object") return val;
  if (typeof val === "string") {
    const t = val.trim();
    if (!t) return fallback;
    try {
      return JSON.parse(t);
    } catch {
      return fallback;
    }
  }
  return fallback;
}

export function normalizeSeatStructure(raw = {}) {
  const removedSeats = parseJsonField(raw.removed_seats, []);
  const seatMap = parseJsonField(raw.seat_map, null);

  return {
    ...raw,
    left_seat: raw.left_seat ?? 2,
    right_seat: raw.right_seat ?? 2,
    total_rows: raw.total_rows ?? 0,
    mid_space: raw.mid_space ?? 1,
    layout: raw.layout ?? "2X2",
    seat_map: seatMap,
    removed_seats: removedSeats,
  };
}
